import { render, staticRenderFns } from "./MnrcvTrsaccAmt.vue?vue&type=template&id=6f339be8"
import script from "./MnrcvTrsaccAmt.vue?vue&type=script&lang=js"
export * from "./MnrcvTrsaccAmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f339be8')) {
      api.createRecord('6f339be8', component.options)
    } else {
      api.reload('6f339be8', component.options)
    }
    module.hot.accept("./MnrcvTrsaccAmt.vue?vue&type=template&id=6f339be8", function () {
      api.rerender('6f339be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/MnrcvTrsaccAmt.vue"
export default component.exports